<template>
  <div id="XyContent">
    <van-nav-bar fixed left-arrow @click-left="goBack" class="tltle">
      <div slot="title">消息列表</div>
    </van-nav-bar>
    <div id="XyHouseEditor" class="newsDetail">
      <div class="mail-main">
        <div class="mail-topbox">
            <span class="mail-tit" v-cloak>
                {{info.Body[0].Value}}
            </span>
            <span class="mail-info" v-cloak>
                <span v-cloak>
                    {{info.CreateByDate}}
                </span>
                <span v-cloak>
                    发送者：{{info.SenderName}}
                </span>
            </span>
        </div>
        <div class="mail-cont" v-cloak>
            <div class="mail-list" v-for="(item,bItem) in info.Body" :key="bItem">
                <div class="msg-info">
                    <span class="msg-key" v-cloak>{{item.Key}}：</span>
                    <span class="msg-val" v-cloak>{{item.Value}}</span>
                </div>
                <div class="li-box" v-if="item.Childrens.length>0">
                    <div class="msg-info" v-for="(child,cItem) in item.Childrens" :key="cItem">
                        <span class="msg-key" v-cloak>{{child.Key}}：</span>
                        <span class="msg-val" v-cloak>{{child.Value}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
    name:'messageDetail',
    data () {
        return {
          info: '',
          mainList: [],
          type: '',
          urlPath: '',
          MessageID: 0,
        }
    },
    created () {
      this.info = JSON.parse(this.$store.state.messageInfo);
      this.info.Body = JSON.parse(this.info.Body);
      // this.type = this.$route.query.fromMessage;
      // type true  消息列表传过来的值,
      // type false 站内信传来的值
      // if (this.type) {
      //     this.urlPath = this.info.ServiceDoMainName;
      //     this.MessageID = this.info.BusinessID;
      // } else {
      //     this.urlPath = this.$store.state.apiPath;
      //     this.MessageID = this.info.MessageID;
      // }
    },
    mounted () {
    },
    methods: {
      //返回消息列表
      goBack () {
          if (this.SourceType === 0) {
              //0 跳转至首页
              if(this.pathSource === 'XyIndex'){
                this.$router.go(-1);
                return
              }
              this.$router.go(-2);
          } else {
              //1 跳转至消息列表
              this.$router.go(-1);
          }
      }
    },
}
</script>

<style lang="less" scoped>
#XyContent {
  padding-top: 90px;
}
.tltle {
  background: #4196ff;
  height: 90px;
  line-height: 90px;
}
.tltle div {
  color: #ffffff;
}

.van-icon-arrow-left:before {
  content: "\F008";
  color: #ffffff;
}
/*消息详情引入的通用样式*/
.newsDetail {
    margin-top: 21px;
    font-size: 28px;
    color: #666;
}

.newsDetail .news-detail {
    background: #fff;
}
.news-detail .detail-item {
    padding: 0 40px 0;
    min-height: 80px;
    overflow: hidden;
}

.news-detail .detail-item .title {
    color: #333;
    margin-bottom: 2px;
    line-height: 80px;
}
.title-conten{
    line-height: 80px;
}
.news-detail .line {
    width: 100%;
    height: 2px;
    display: block;
    /* margin-left: 0.4rem; */
    position: relative;
    background-color: #f5f5f5;
}
.news-detail .detail-item .con {
    line-height: 42px;
    margin: 20px 0;
    word-break: break-all;
}
.margin-t-15 {
    margin-top: 15px;
}

.mail-main{
  .mail-topbox {
    text-align: center;
    border-bottom: 1px solid #f1f1f1;
    overflow: hidden;
    .mail-tit {
        font-size: 40px;
        font-weight: bold;
        display: block;
        text-align: center;
        margin-bottom: 10px;
    }
    .mail-info {
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(129,129,129,1);
        margin-bottom: 20px;
        display: block;
        span {
            margin: 0 5px;
        }
    }
  }
  .mail-cont {
    margin: 26px 20px;
  }
}
.mail-list {
    border-radius: 8px;
    padding: 5px 16px;
}

.li-box {
    background: rgba(245,245,245,1);
    border-radius: 8px;
    padding: 4px 10px;
}

.msg-info {
    margin: 10px 0;
}

.msg-key {
    font-size: 28px;
    font-weight: 400;
    color: rgba(144,144,144,1);
    line-height: 18px;
}

.msg-val {
    font-size: 28px;
    font-weight: 400;
    color: rgba(51,51,51,1);
    line-height: 18px;
}
</style>
